import { NumberOfMines } from '@/components/templates/Mines/molecules/NumberOfMines/NumberOfMines'
import { Box, SimpleGrid, Flex, FlexProps, Grid } from '@chakra-ui/react'
import Image from 'next/image'
import Mine from '@/public/assets/images/mines/mine.png'
import Gem from '@/public/assets/images/mines/gem.png'

export const MinesGamePlayground = ({
  userChoices,
  mines,
  isVertical = false,
}: {
  userChoices: Array<number>
  mines: Array<number>
  isVertical?: boolean
}) => {
  return (
    <Grid
      gridTemplateColumns={isVertical ? { base: '1fr', sm: 'auto 58px' } : '1fr'}
      gap={isVertical ? 2 : { base: 2, sm: 4 }}
    >
      <NumberOfMines numberOfMines={mines.length} isVertical={isVertical} />
      <SimpleGrid order={isVertical ? { base: 'auto', sm: -1 } : 'auto'} columns={5} gap={{ base: 1, md: 2 }}>
        {Array.from({ length: 25 }, (_, k) => {
          const isUserChoice = userChoices.includes(k)
          const isMine = mines.includes(k)

          return <MinePanel key={k} isMine={isMine} isActive={isUserChoice} />
        })}
      </SimpleGrid>
    </Grid>
  )
}

export const MinePanel = ({ isMine, isActive, styles }: { isMine: boolean; isActive: boolean; styles?: FlexProps }) => {
  return (
    <Flex
      justifyContent={'center'}
      alignItems={'center'}
      bg={'ninja.800'}
      aspectRatio={'1'}
      w={'full'}
      rounded={'xl'}
      p={'20%'}
      boxShadow={`0px -5px 26px 0px ${isMine ? '#FF1B1B' : '#4AF05D'}${!isActive ? '60' : ''} inset;`}
      {...styles}
    >
      <Box opacity={!isActive ? 0.4 : 1}>{isMine ? <Image src={Mine} alt={''} /> : <Image src={Gem} alt={''} />}</Box>
    </Flex>
  )
}
